import type { AnchorKey9, LayoutOverridesForm } from "../../api/posterService";

/**
 * 任务 14(7.29 反馈)· 把用户选的九宫格锚点装配成 `layoutOverrides`。
 *
 * ★这条链路的缺口**只在这里**:后端契约一直是全通的 —— `posterService.ts` 早就声明了
 * `logoAnchor/qrAnchor`,ai 侧 `LayoutOverrides` 收得住,小阳(旁路)也早就能设。
 * 而创建页 `useFreeCreateActions` 主动写着 `layoutOverrides: undefined`,
 * 于是**手动主线比旁路弱**:用户自己做图不能定位置,让 AI 代做反而能。
 *
 * ★两条口径:
 * ① 都没选(都是「自动」)→ 返 `undefined`,**不发空对象**。发 `{}` 会让 ai 侧
 *   `layout_overrides` 从 None 变成一个空模型,`overlay_autoplace` 里
 *   `bool(layout_overrides and layout_overrides.logo_anchor)` 虽然仍是 False,
 *   但语义上「用户做过决定」和「用户没做决定」不该长一样。
 * ② **没挂 logo 就不发 logoAnchor** —— 给一个不存在的元素定位置是无意义的脏数据,
 *   而它会随任务落库、被「重新创作」原样带回来。
 */
export function buildLayoutOverrides(input: {
  logoAnchor: AnchorKey9 | null;
  qrAnchor: AnchorKey9 | null;
  hasLogo: boolean;
  hasQr: boolean;
}): LayoutOverridesForm | undefined {
  const out: LayoutOverridesForm = {};
  if (input.hasLogo && input.logoAnchor) {
    out.logoAnchor = input.logoAnchor;
  }
  if (input.hasQr && input.qrAnchor) {
    out.qrAnchor = input.qrAnchor;
  }
  return Object.keys(out).length > 0 ? out : undefined;
}
